const log = {
  viewtitle: 'Activity Log',
  sitename: 'Sitename',
  type: 'Type',
  result: 'State',
  date: 'Date',
  details: 'Details',
  entersitename: 'Enter Sitename',
  toversion: 'Version',
  activity: {
    newsitecreated: 'New Site Created',
    siteupdate: 'Updated Site Data',
    backupteststarted: 'Backup Test Started',
    backuptestfailed: 'Backup Test Failed',
    backuptestfinished: 'Backup Test Finished',
    backuptestsuccess: 'Backup Test Successfully Finished',
    extensionupdate: 'Extension Updated',
    extensionupdatesuccess: 'Extension Successfully Updated',
    backupstarted: 'Backup Started',
    backupfinished: 'Backup Finished',
    coreupdate: 'Core Updated',
    extensionupdatefailed: 'Extension Update Failed',
    siteupdatesuccess: 'Site Information Updated',
    coreupdatesuccess: 'Core successfully updated',
    siteupdatefailed: 'Updating site data failed',
    extensionmanualupdatedetected: 'Manual Extension Update Detected',
    coremanualupdatedetected: 'Manual Core Update Detected',
    extensiondeleted: 'Extension deleted',
    backupauditfinished: 'Security Audit finished',
    backupauditsuccess: 'Security Audit Success',
    backauditfailed: 'Security Audit Failed',
    autoextensionupdatefailed: 'Automatic Extension Update Failed',
    autoextensionupdatefinallyfailed: 'Automatic Extension Update Disabled',
    autoextensionupdatesuccess: 'Automatic Extension Update Successfully Finished',
    extensionupdatedetected: 'Extension Update Detected',
    coreupdatedetected: 'Core Update Detected',
    coreupdatefailed: 'Core Update Failed',
    backupfailed: 'Backup failed'
  }
}

export default log
